import React, { useState, useCallback } from "react";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { BiEdit } from "react-icons/bi";
import { FiEye, FiPrinter, FiTrash2 } from "react-icons/fi";
import { MdMoreVert } from "react-icons/md";

const InvoiceBrowseActionsMenu = ({ row, onView, onEdit, onDelete, onPrint }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = useCallback(() => setAnchorEl(null), []);

  const handleOpen = useCallback((e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  }, []);

  return (
    <>
      <IconButton
        size="small"
        aria-label="invoice actions"
        onClick={handleOpen}
        sx={{ color: "#155f60" }}
      >
        <MdMoreVert />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              minWidth: 180,
              borderRadius: "12px",
              border: "1px solid #E5E9EB",
              boxShadow:
                "0 4px 12px rgba(16,69,70,0.08), 0 12px 28px rgba(16,69,70,0.08)",
            },
          },
        }}
      >
        <MenuList dense autoFocusItem>
          {typeof onView === "function" && (
            <MenuItem
              onClick={() => {
                onView(row);
                handleClose();
              }}
            >
              <ListItemIcon>
                <FiEye className="text-lg text-inkSecondary" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontFamily: "Quicksand" }}>
                View
              </ListItemText>
            </MenuItem>
          )}
          {typeof onEdit === "function" && (
            <MenuItem
              onClick={() => {
                onEdit(row);
                handleClose();
              }}
            >
              <ListItemIcon>
                <BiEdit className="text-lg text-main" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontFamily: "Quicksand" }}>
                Edit
              </ListItemText>
            </MenuItem>
          )}
          {typeof onDelete === "function" && (
            <MenuItem
              onClick={() => {
                onDelete(row);
                handleClose();
              }}
            >
              <ListItemIcon>
                <FiTrash2 className="text-lg text-danger" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontFamily: "Quicksand" }}
              >
                Delete
              </ListItemText>
            </MenuItem>
          )}
          {typeof onPrint === "function" && (
            <MenuItem
              onClick={() => {
                onPrint(row);
                handleClose();
              }}
            >
              <ListItemIcon>
                <FiPrinter className="text-lg text-main" />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontFamily: "Quicksand" }}>
                Print
              </ListItemText>
            </MenuItem>
          )}
        </MenuList>
      </Popover>
    </>
  );
};

export default InvoiceBrowseActionsMenu;
